import { param } from 'jquery';

// 語言列表
var languageMenu = [{ name: 'tw', folder: 'Tw' }, { name: 'en', folder: 'En' }];
// 需全畫面呈現檔案名稱
var fullScreen = ['site-tour', 'business', 'product-service', 'about-yfc', 'stakeholder', 'recruit_new'];
// var fullScreen = ['site-tour', 'business', 'product-service', 'about-yfc', 'stakeholder'];

// 選單列表
// key為資料夾名稱
// page為vue檔案名稱
var Menulist = [{
            level: '1',
            key: 'about-tac',
            tw_value: '關於裕融',
            en_value: 'About YFC',
            sub_menu: [{
                level: '2',
                key: 'news-center',
                tw_value: '新聞中心',
                en_value: 'news-center',
                page: 'news-center',
                img_name: 'banner-about-01'
            }, {
                level: '2',
                key: 'management-philosophy',
                tw_value: '公司簡介',
                en_value: 'Corporate Profile',
                page: 'management-philosophy',
                img_name: 'banner-about-02'
            }, {
                level: '2',
                key: 'management-group',
                tw_value: '經營團隊',
                en_value: 'management-group',
                page: 'management-group',
                img_name: 'banner-about-03'
            }, {
                level: '2',
                key: 'certificate',
                tw_value: '榮耀獎項',
                en_value: 'certificate',
                page: 'certificate',
                img_name: 'banner-about-04'
            }, {
                level: '2',
                key: 'related-company',
                tw_value: '關係企業',
                en_value: 'related-company',
                page: 'related-company',
                img_name: 'banner-about-05'
            }, {
                level: '2',
                key: 'service-dealer',
                tw_value: '服務據點',
                en_value: 'service-dealer',
                page: 'service-dealer',
                img_name: 'banner-about-05'
            }]
        }, {
            level: '1',
            key: 'product-service',
            tw_value: '產品及服務',
            en_value: 'Our Service',
            page: 'product-service',
            img_name: 'banner-product-01',
        },
        {
            level: '1',
            key: 'business',
            tw_value: '公司治理',
            en_value: 'business',
            page: 'business',
            img_name: 'banner-business-04'
        }, {
            level: '1',
            key: 'sustainable-development',
            tw_value: '永續發展',
            en_value: 'sustainable-development',
            sub_menu: [{
                    level: '2',
                    key: 'sustainable-operating',
                    tw_value: '永續經營',
                    en_value: 'sustainable-operating',
                    sub_menu: [{
                            level: '3',
                            key: 'operators',
                            tw_value: '經營者的話',
                            en_value: 'operators',
                            page: 'operators',
                            img_name: 'banner-csr-15'
                        }, {
                            level: '3',
                            key: 'sustainable-strategy-operation',
                            tw_value: '永續策略',
                            en_value: 'sustainable-strategy-operation',
                            page: 'sustainable-strategy-operation',
                            img_name: 'banner-csr-01'
                        }, {
                            level: '3',
                            key: 'sustainable-performance',
                            tw_value: '永續績效',
                            en_value: 'sustainable-performance',
                            page: 'sustainable-performance',
                            img_name: 'banner-csr-16'
                        }, 
                        // {
                        //     level: '3',
                        //     key: 'sustainable-introduction',
                        //     tw_value: '永續運作',
                        //     en_value: 'sustainable-introduction',
                        //     page: 'sustainable-introduction',
                        //     img_name: 'banner-csr-01'
                        // },
                        {
                            level: '3',
                            key: 'stakeholder-identification',
                            tw_value: '利害關係人鑑別',
                            en_value: 'Stakeholder identification',
                            page: 'stakeholder-identification',
                            img_name: 'banner-business-01'
                        },
                        {
                            level: '3',
                            key: 'significant-issue',
                            tw_value: '重大性議題鑑別',
                            en_value: 'Significant Issue',
                            page: 'significant-issue',
                            img_name: 'banner-business-01'
                        },
                        {
                            level: '3',
                            key: 'stakeholder-channel',
                            tw_value: '利害關係人溝通',
                            en_value: 'Stakeholder Channel',
                            page: 'stakeholder-channel',
                            img_name: 'banner-business-01'
                        },
                        {
                            level: '3',
                            key: 'csr-download',
                            tw_value: '永續報告書下載區',
                            en_value: 'csr-download',
                            page: 'csr-download',
                            img_name: 'banner-csr-14'
                        }
                    ]
                },
                {
                    level: '2',
                    key: 'operating-governance',
                    tw_value: '經營治理',
                    en_value: 'operating-governance',
                    sub_menu: [{
                            level: '3',
                            key: 'corporate-governance',
                            tw_value: '公司治理',
                            en_value: 'corporate-governance',
                            page: 'corporate-governance',
                            img_name: 'banner-csr-03'
                        }, {
                            level: '3',
                            key: 'succession-plan',
                            tw_value: '接班計畫',
                            en_value: 'succession-plan',
                            page: 'succession-plan',
                            img_name: 'banner-csr-03'
                        }, {
                            level: '3',
                            key: 'compliance',
                            tw_value: '法令遵循',
                            en_value: 'compliance',
                            page: 'compliance',
                            img_name: 'banner-csr-03'
                        }, {
                            level: '3',
                            key: 'information-disclosure',
                            tw_value: '資訊揭露',
                            en_value: 'information-disclosure',
                            page: 'information-disclosure',
                            img_name: 'banner-csr-03'
                        }, {
                            level: '3',
                            key: 'integrity-management',
                            tw_value: '誠信經營',
                            en_value: 'integrity-management',
                            page: 'integrity-management',
                            img_name: 'banner-csr-03'
                        }, {
                            level: '3',
                            key: 'risk-management',
                            tw_value: '風險管理',
                            en_value: 'risk-management',
                            page: 'risk-management',
                            img_name: 'banner-csr-03'
                        }
                    ]
                }, {
                    level: '2',
                    key: 'customer-worth',
                    tw_value: '顧客價值',
                    en_value: 'customer-worth',
                    sub_menu: [{
                        level: '3',
                        key: 'customer-privacy',
                        tw_value: '個資保護',
                        en_value: 'customer-privacy',
                        page: 'customer-privacy',
                        img_name: 'banner-csr-04'
                    }, {
                        level: '3',
                        key: 'customer-service',
                        tw_value: '顧客服務',
                        en_value: 'customer-service',
                        page: 'customer-service',
                        img_name: 'banner-csr-04'
                    },{
                        level: '3',
                        key: 'customer-relationship',
                        tw_value: '顧客關係',
                        en_value: 'customer-relationship',
                        page: 'customer-relationship',
                        img_name: 'banner-csr-04'
                    }
                ]
                }, {
                    level: '2',
                    key: 'happy-workplace',
                    tw_value: '幸福職場',
                    en_value: 'happy-workplace',
                    sub_menu: [{
                            level: '3',
                            key: 'human-right',
                            tw_value: '人權政策',
                            en_value: 'human-right',
                            page: 'human-right',
                            img_name: 'banner-csr-08'
                        },  {
                            level: '3',
                            key: 'employee-care',
                            tw_value: '員工照顧',
                            en_value: 'employee-care',
                            page: 'employee-care',
                            img_name: 'banner-csr-05'
                        }, {
                            level: '3',
                            key: 'cultivation-and-development',
                            tw_value: '人才培育',
                            en_value: 'cultivation-and-development',
                            page: 'cultivation-and-development',
                            img_name: 'banner-csr-05'
                        }, 
                        {
                            level: '3',
                            key: 'industrial-relations',
                            tw_value: '勞資和諧',
                            en_value: 'industrial-relations',
                            page: 'industrial-relations',
                            img_name: 'banner-csr-05'
                        },
                    ]
                }, {
                    level: '2',
                    key: 'environment-sustainable',
                    tw_value: '綠色永續',
                    en_value: 'environment-sustainable',
                    sub_menu: [{
                            level: '3',
                            key: 'climate-change',
                            tw_value: '氣候變遷',
                            en_value: 'climate-change',
                            page: 'climate-change',
                            img_name: 'banner-csr-11'
                        },{
                            level: '3',
                            key: 'green-sustainable',
                            tw_value: '營運永續',
                            en_value: 'green-sustainable',
                            page: 'green-sustainable',
                            img_name: 'banner-csr-06'
                        },
                        // {
                        //     level: '3',
                        //     key: 'green-sustainable',
                        //     tw_value: '環境目標',
                        //     en_value: 'green-sustainable',
                        //     page: 'green-sustainable',
                        //     img_name: 'banner-csr-04'
                        // },
                        // {
                        //     level: '3',
                        //     key: 'carbon-reduction',
                        //     tw_value: '減碳作為',
                        //     en_value: 'Carbon reduction',
                        //     page: 'carbon-reduction',
                        //     img_name: 'banner-csr-06'
                        // },
                        {
                            level: '3',
                            key: 'development-green-energy',
                            tw_value: '綠能投資',
                            en_value: 'development-green-energy',
                            page: 'development-green-energy',
                            img_name: 'banner-csr-13'
                        }, {
                            level: '3',
                            key: 'environmental-protection',
                            tw_value: '循環永續',
                            en_value: 'environmental-protection',
                            page: 'environmental-protection',
                            img_name: 'banner-csr-06'
                        }, {
                            level: '3',
                            key: 'supplier-management',
                            tw_value: '供應商管理',
                            en_value: 'supplier-management',
                            page: 'supplier-management',
                            img_name: 'banner-csr-12'
                        }
                    ]
                }, {
                    level: '2',
                    key: 'society-join',
                    tw_value: '社會參與',
                    en_value: 'society-join',
                    sub_menu: [{
                        level: '3',
                        key: 'strategy',
                        tw_value: '社會創新策略',
                        en_value: 'strategy',
                        page: 'strategy',
                        img_name: 'banner-csr-07'
                    },
                    {
                        level: '3',
                        key: 'social-impact',
                        tw_value: '創新移動影響力',
                        en_value: 'social-impact',
                        page: 'social-impact',
                        img_name: 'banner-csr-09'
                    },
                    {
                        level: '3',
                        key: 'faas',
                        tw_value: '普惠金融服務',
                        en_value: 'faas',
                        page: 'faas',
                        img_name: 'banner-csr-07'
                    },
                    
                    {
                        level: '3',
                        key: 'rural-connection',
                        tw_value: '偏鄉接駁與創生',
                        en_value: 'rural-connection',
                        page: 'rural-connection',
                        img_name: 'banner-csr-07'
                    }, {
                        level: '3',
                        key: 'charitable-activities',
                        tw_value: '公益參與',
                        en_value: 'charitable-activities',
                        page: 'charitable-activities',
                        img_name: 'banner-csr-10'
                    }, ]
                },
                // {
                //     level: '2',
                //     key: 'supplier-management',
                //     tw_value: '供應商管理',
                //     en_value: 'supplier-management',
                //     sub_menu: [{
                //         level: '3',
                //         key: 'supplier-policy',
                //         tw_value: '供應商管理政策',
                //         en_value: 'supplier-policy',
                //         page: 'supplier-policy',
                //         img_name: 'banner-csr-07'
                //     }, {
                //         level: '3',
                //         key: 'supplier-result',
                //         tw_value: '供應商管理成果',
                //         en_value: 'supplier-result',
                //         page: 'supplier-result',
                //         img_name: 'banner-csr-07'
                //     }, ]
                // }
            ]
        }, {
            level: '1',
            key: 'investment',
            tw_value: '投資人關係',
            en_value: 'For Investors',
            sub_menu: [{
                level: '2',
                key: 'company-information',
                tw_value: '公司資訊',
                en_value: 'company-information',
                sub_menu: [{
                    level: '3',
                    key: 'company-info',
                    tw_value: '基本資料',
                    en_value: 'company-info',
                    page: 'company-info',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'credit-rating',
                    tw_value: '信用評等',
                    en_value: 'credit-rating',
                    page: 'credit-rating',
                    img_name: 'banner-finance-01'
                }]
            }, {
                level: '2',
                key: 'finance-information',
                tw_value: '財務資訊',
                en_value: 'Financial information',
                sub_menu: [{
                    level: '3',
                    key: 'monthly-revenue-information',
                    tw_value: '每月營收資訊',
                    en_value: 'Monthly Revenue',
                    page: 'monthly-revenue-information',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'monthly-surplus',
                    tw_value: '每月自結盈餘',
                    en_value: 'Monthly Net Profits',
                    page: 'monthly-surplus',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'financial-report',
                    tw_value: '財務報告',
                    en_value: 'Financial Statements',
                    page: 'financial-report',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'company-annual-report',
                    tw_value: '公司年報',
                    en_value: 'Annual Report',
                    page: 'company-annual-report',
                    img_name: 'banner-finance-01'
                }, ]
            }, {
                level: '2',
                key: 'shareholder-service',
                tw_value: '股東與投資人專區',
                en_value: 'Shareholder&Investor Services',
                sub_menu: [{
                    level: '3',
                    key: 'shareholder-structure',
                    tw_value: '前十大股東',
                    en_value: 'shareholder-structure',
                    page: 'shareholder-structure',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'shareholders-meeting',
                    tw_value: '股東會',
                    en_value: `Shareholder's Meeting`,
                    page: 'shareholders-meeting',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'stock-price-information',
                    tw_value: '股價資訊',
                    en_value: 'stock-price-information',
                    isInternal: 'Y',
                    page: 'https://mis.twse.com.tw/stock/fibest.jsp?stock=9941'
                }, {
                    level: '3',
                    key: 'dividend-distribution',
                    tw_value: '股利資訊',
                    en_value: 'dividend-distribution',
                    page: 'dividend-distribution',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'institutional-investors',
                    tw_value: '法人說明會',
                    en_value: 'institutional-investors',
                    page: 'institutional-investors',
                    img_name: 'banner-finance-01'
                }, {
                    level: '3',
                    key: 'material-information',
                    tw_value: '重大訊息',
                    en_value: 'material-information',
                    page: 'material-information',
                    img_name: 'banner-finance-01'
                },
                {
                    level: '3',
                    key: 'operational-summary',
                    tw_value: '營運概要與展望',
                    en_value: 'operational-summary',
                    page: 'operational-summary',
                    img_name: 'banner-finance-01'
                },
                {
                    level: '3',
                    key: 'stock-affairs',
                    tw_value: '股務聯繫',
                    en_value: 'stock-affairs',
                    page: 'stock-affairs',
                    img_name: 'banner-finance-01'
                }
            ]
            }]
        },
        {
            level: '1',
            key: 'stakeholder',
            tw_value: '利害關係人',
            en_value: 'stakeholder',
            page: 'stakeholder',
            img_name: 'banner-business-01',
        },
        // {
        //     level: 'headerlink',
        //     key: 'recruiting',
        //     tw_value: '加入裕融',
        //     en_value: 'recruit',
        //     page: 'recruit',
        //     img_name: 'banner-joinus-01',
        //     sub_menu: [{
        //             level: '2',
        //             key: 'salary',
        //             tw_value: '薪資福利',
        //             en_value: 'salary',
        //             page: 'salary',
        //             img_name: 'banner-joinus-01',
        //         },
        //         {
        //             level: '2',
        //             key: 'nurture',
        //             tw_value: '多元培育',
        //             en_value: 'nurture',
        //             page: 'nurture',
        //             img_name: 'banner-joinus-01',
        //         },
        //         {
        //             level: '2',
        //             key: 'recruiting',
        //             tw_value: '招募訊息',
        //             en_value: 'recruit',
        //             page: 'recruit',
        //             img_name: 'banner-joinus-01',
        //         }]
        // },
        // 現在的加入裕融頁面
        // {
        //     level: 'headerlink',
        //     key: 'recruiting',
        //     tw_value: '加入裕融',
        //     en_value: 'recruit',
        //     page: 'recruit_new',
        //     img_name: 'banner-joinus-01'
        // },
        // 要改成這樣的加入裕融頁面1
        // {
        //     level: 'headerlink',
        //     key: 'recruiting',
        //     tw_value: '加入裕融',
        //     en_value: 'recruit',
        //     page: 'recruit',
        //     img_name: 'banner-joinus-01',
        //     sub_menu: [{
        //             level: '2',
        //             key: 'salary',
        //             tw_value: '薪資福利',
        //             en_value: 'salary',
        //             page: 'salary',
        //             img_name: 'banner-joinus-01',
        //         },
        //         {
        //             level: '2',
        //             key: 'nurture',
        //             tw_value: '多元培育',
        //             en_value: 'nurture',
        //             page: 'nurture',
        //             img_name: 'banner-joinus-01',
        //         },
        //         {
        //             level: '2',
        //             key: 'recruiting',
        //             tw_value: '招募訊息',
        //             en_value: 'recruit',
        //             page: 'recruit',
        //             img_name: 'banner-joinus-01',
        //         }]
        // },
        
        //要改成這樣的加入裕融頁面2
        {
                level: 'headerlink',
                key: 'recruiting',
                tw_value: '加入裕融',
                en_value: 'recruit',
                page: 'recruit_new2',
                img_name: 'banner-joinus-01',
                sub_menu: [{
                            level: '2',
                            key: 'recruiting',
                            tw_value: '招募訊息',
                            en_value: 'recruit',
                            page: 'recruit_new2',
                            img_name: 'banner-joinus-01',
                        },                        
                        {
                            level: '2',
                            key: 'talent-sustainability',
                            tw_value: '人才永續',
                            en_value: 'talent-sustainability',
                            page: 'talent-sustainability',
                            img_name: 'banner-joinus-01',
                        }]
            },
        {
            level: 'headerlink',
            key: 'site',
            tw_value: '網站導覽',
            en_value: 'site-tour',
            page: 'site-tour'
        }
    ]
// 選單列表
// key為資料夾名稱
// page為vue檔案名稱
var EnMenulist = [{
        level: '1',
        key: 'about-yfc',
        en_value: 'About YFC',
        page: 'about-yfc',
        img_name: 'banner-about-02'
    }, {
        level: '1',
        key: 'product-service',
        en_value: 'Our Service',
        page: 'product-service',
        img_name: 'banner-product-01',
    }, {
        level: '1',
        key: 'sustainability',
        en_value: 'Sustainability',
        page: 'sustainability',
        img_name: 'banner-product-01',
    }, {
        level: '1',
        key: 'investment',
        en_value: 'For Investors',
        sub_menu: [{
            level: '2',
            key: 'finance-information',
            en_value: 'Financial information',
            sub_menu: [{
                level: '3',
                key: 'monthly-revenue-information',
                en_value: 'Monthly Revenue',
                page: 'monthly-revenue-information',
                img_name: 'banner-finance-01'
            }, {
                level: '3',
                key: 'monthly-surplus',
                en_value: 'Monthly Net Profits',
                page: 'monthly-surplus',
                img_name: 'banner-finance-01'
            }, {
                level: '3',
                key: 'financial-report',
                en_value: 'Financial Statements',
                page: 'financial-report',
                img_name: 'banner-finance-01'
            }, {
                level: '3',
                key: 'company-annual-report',
                en_value: 'Annual Report',
                page: 'company-annual-report',
                img_name: 'banner-finance-01'
            }]
        }, {
            level: '2',
            key: 'shareholder-service',
            en_value: 'Shareholder&Investor Services',
            sub_menu: [
            {
                level: '3',
                key: 'shareholders-meeting',
                en_value: `Shareholder's Meeting`, // 股東會
                page: 'shareholders-meeting',
                img_name: 'banner-finance-01'
            }, {
                level: '3',
                key: 'stock-price-information',
                en_value: 'Stock Information', // 股價資訊
                isInternal: 'Y',
                page: 'https://mis.twse.com.tw/stock/fibest.jsp?stock=9941&lang=en_us&oddFlag=false'
            }, {
                level: '3',
                key: 'institutional-investors',
                en_value: 'Investor Conference', // 法說會
                page: 'institutional-investors',
                img_name: 'banner-finance-01'
            },{
                level: '3',
                key: 'material-information',
                en_value: 'Material Information', // 重大消息
                page: 'material-information',
                img_name: 'banner-finance-01'
            },
            // {
            //     level: '3',
            //     key: 'material-information',
            //     en_value: 'Material Information', // 重大消息
            //     isInternal: 'Y',
            //     page: 'https://emops.twse.com.tw/server-java/t05st01_e?TYPEK=sii&co_id=9941&year='+new Date().getFullYear()+'&month=all&step=0&query=co&colorchg=1'
            //     }
            ]
        }]
    }, {
        level: '1',
        key: 'contact-us',
        en_value: 'Contact us',
        isInternal: 'Y',
        page: 'mailto:service@tac.com.tw',
        img_name: 'banner-finance-01'
    },
    // {
    //     level: 'headerlink',
    //     key: 'site',
    //     en_value: 'site-tour',
    //     page: 'site-tour'
    // }
]

// 回傳Router表
var resultList = [{
        path: '/',
        name: '首頁',
        isFull: true,
        component: () =>
            import ('@/page/Index')
    },
    {
        path: '/En',
        name: 'Home',
        isFull: true,
        component: () =>
            import ('@/page/Index_en')
    },
    // 將不是路由設定都導回首頁
    { path: "*", redirect: '/' }
];
// 綁定路由功能
function bundle(l, obj, importPath, parentItem) {
    // 遞迴中使用的選單集合
    var mainMenu = [];
    obj.forEach(m => {
        // 判斷是否為第一層或標頭連結，True:加入語系開頭、false:當前路由名稱
        var currentUrl = m.level === '1' || m.level === 'headerlink' ? '/' + l.folder + '/' + m.key : m.key;
        // 產生RouterConfig
        var routerPage = {
            path: currentUrl, // 設定路由位置
            //alias: m.level, // 取不同階層
            name: m[l.name + '_value'], // 取不同語言選單名稱
            parentName: parentItem, // 若為子層時需加入上層key
            currentKey: m.key, // 當前層名稱
            language: l.folder, //語言
            showClass: m.level // 取不同階層
        };
        // 判斷是否有子選單
        if (m.sub_menu !== undefined) {
            if (m.page !== undefined) {
                // 若有檔案頁面時加入該檔案頁面                
                routerPage.hasPage = 'Y';
                // 若有圖檔時加入圖檔名稱
                if (m.img_name !== undefined) {
                    routerPage.props = m.img_name;
                }
                // 判斷vue名稱是否需要全屏
                if (fullScreen.indexOf(m.page) > -1) {
                    routerPage.isFull = true;
                }
                if (m.level === '1' || m.level === 'headerlink') {

                    routerPage.components = {
                        default: () =>
                            import ('@/page/Layout'),
                        mainpage: () =>
                            import ('@/page' + currentUrl + '/' + m.page)
                    }
                } else {
                    routerPage.components = {
                        default: () =>
                            import ('@/page/Layout'),
                        secondpage: () =>
                            import ('@/page/' + l.folder + '/' + parentItem + '/' + currentUrl + '/' + m.page)
                    }
                }
            } else {
                // 上層選單需import有RoutView檔案
                routerPage.component = () =>
                    import ('@/page/Layout')
            }
            // 遞迴產生子選單
            routerPage.children = bundle(l, m.sub_menu, importPath + '/' + m.key, m.key)
            mainMenu.push(routerPage)
        } else { // 最後一層
            if (m.page !== undefined) {
                // 若有圖檔時加入圖檔名稱
                if (m.img_name !== undefined) {
                    routerPage.props = m.img_name;
                }
                // 判斷vue名稱是否需要全屏
                if (fullScreen.indexOf(m.page) > -1) {
                    routerPage.isFull = true;
                }
                // 設定讀取import資料夾
                var importFolder = l.folder + (importPath === '' ? '/' + m.key : importPath) + '/' + m.page;
                if (m.isInternal === 'Y') {
                    routerPage.internalUrl = m.page
                } else {
                    routerPage.component = () =>
                        import ('@/page/' + importFolder)
                }
                mainMenu.push(routerPage)
            } else {
                // 空選單import有RoutView檔案
                routerPage.component = () =>
                    import ('@/page/Layout')
                mainMenu.push(routerPage)
            }
        }
        // 結束遞迴時判斷為第一層將結果PUSH至回傳路由集合
        if (m.level === '1' || m.level === 'headerlink') {
            resultList.push(routerPage)
        }
    });
    // 遞迴回傳用
    return mainMenu
}
// 取得選單列表
function getMenuList() {
    languageMenu.forEach(language => {
        if (language.name === 'tw') {
            bundle(language, Menulist, '', '');
        } else {
            bundle(language, EnMenulist, '', '');
        }
    })
}
// 判斷是否需全屏
function isFullScreen(url, router) {
    var str = url;
    var routers = router;
    languageMenu.forEach(o => {
        str = str.replace('/' + o.folder + '/', '');
    });
    if (str !== '/') {
        str.split('/').forEach(o => {
            routers = selector(routers, o)
        })
        return routers.isFull ? routers.isFull : false
    } else {
        return true
    }
}
// 判斷父階層是否呈現
function parentIsShow(url, router, seletorClass) {
    var result = selectorSingle(url, router);
    return seletorClass.indexOf(o => o === result.showClass) && result.components !== undefined
}
// 取得目前語言
function getLanguage() {
    var result = window.location.pathname.indexOf('En') > -1 ? 'en' : 'tw';
    return result
}

// 搜尋到該頁面的Router
function selectorSingle(url, router) {
    var str = url;
    var routers = router;
    languageMenu.forEach(o => {
        str = str.replace('/' + o.folder + '/', '');
    });
    if (str !== '/') {
        str.split('/').forEach((o, i) => {
            if (i !== str.split('/').length - 1) {
                routers = selector(routers, o)
            } else {
                routers = routers.find(g => g.currentKey === o)
            }
        })
        return routers
    } else {
        return routers.find(o => o.path === '/')
    }
}

// 取得該網頁第一層路由
function getFisrtRouter(url, router) {
    var routers = router;
    var pathName = '';
    var result = {};
    url.split('/').forEach((o, i) => {
        if (i === 0) {} else if (i === 1) {
            pathName += '/' + o;
            routers = routers.filter(g => g.language === o);
        } else if (i === 2) {
            pathName += '/' + o;
            routers = routers.find(g => g.currentKey === o)
        } else {
            return false;
        }
    })
    result.fristPath = pathName;
    result.routerItem = routers;
    return result
}

function selector(arr, param, seletorType) {
    var result = arr.find(o => o.currentKey === param)
    if (result.children !== undefined) {
        return result.children;
    } else {
        return result
    }
}



export { // Js回傳功能用很關鍵
    getMenuList,
    isFullScreen,
    parentIsShow,
    getFisrtRouter,
    getLanguage,
    resultList,
    router
}


// WEBPACK FOOTER //
// ./src/router/routerSetting.js